import { Component, Input, ViewChild, OnInit, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Clipboard } from '@angular/cdk/clipboard';
import { faCopy } from '@fortawesome/free-regular-svg-icons';

/**
 * クリップボードへのコピーアイコンクラス
 *
 * @export ClipboardCopyIconComponent
 * @class ClipboardCopyIconComponent
 */
@Component({
  selector: 'app-clipboard-copy-icon',
  templateUrl: 'clipboard-copy-icon.component.html',
  styleUrls: ['clipboard-copy-icon.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ClipboardCopyIconComponent,
      multi: true,
    },
  ]
})
export class ClipboardCopyIconComponent implements OnInit, ControlValueAccessor {

  @ViewChild('button', { static: true }) public button: ElementRef;

  @Input() public subid: string = null;
  /** パネル幅 */
  @Input() width: number = <number>0;
  /** パネル高さ */
  @Input() height: number = <number>0;
  /** 強制活性モードフラグ */
  @Input() forcedEnabledMode: string = null;
  /** ラベル */
  @Input() label: string = null;
  /** ID */
  @Input() id: string = null;
  /** 名前 */
  @Input() name: string = null;
  /** 値 */
  @Input() value: string = null;
  /** タブインデックス */
  @Input() tabindex: number = null;
  /** 可視フラグ デフォルトはtrue*/
  @Input() visible: boolean = <boolean>true;
  /** 活性フラグ  デフォルトはtrue*/
  @Input() public disabled: boolean = <boolean>false;
  /** フォントサイズ */
  @Input() fontSize: number = null;
  /** 選択 */
  @Input() checked: boolean = <boolean>false;
  /** autofocus */
  @Input() autofocus: boolean = <boolean>false;
  /** ツールチップ */
  @Input() tooltip: string = null;

  iconCopy = faCopy

  /**
   * Creates an instance of ClipboardCopyIconComponent.
   * @memberof ClipboardCopyIconComponent
   */
  constructor(
    public elementRef: ElementRef,
    private clipboard: Clipboard
  ) { }

  writeValue(value: string) {}
  onChange(value: string) {}
  onTouched() { }
  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  /**
   * 初期処理
   *
   * @memberof ClipboardCopyIconComponent
   */
  ngOnInit() {}

  /**
   * ボタン押下
   */
  public onClick(): void {
    this.clipboard.copy(this.value);
  }
}
